function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// Note: This regex matches even invalid JSON strings, but since we’re
// working on the output of `JSON.stringify` we know that only valid strings
// are present (unless the user supplied a weird `options.indent` but in
// that case we don’t care since the output would be invalid anyway).
var stringOrChar = /("(?:[^\\"]|\\.)*")|[:,]/g;
export default function stringify(passedObj) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var indent = JSON.stringify([1], undefined, options.indent === undefined ? 2 : options.indent).slice(2, -3);
  var maxLength = indent === "" ? Infinity : options.maxLength === undefined ? 80 : options.maxLength;
  var replacer = options.replacer;
  return function _stringify(obj, currentIndent, reserved) {
    if (obj && typeof obj.toJSON === "function") {
      obj = obj.toJSON();
    }
    var string = JSON.stringify(obj, replacer);
    if (string === undefined) {
      return string;
    }
    var length = maxLength - currentIndent.length - reserved;
    if (string.length <= length) {
      var prettified = string.replace(stringOrChar, function (match, stringLiteral) {
        return stringLiteral || "".concat(match, " ");
      });
      if (prettified.length <= length) {
        return prettified;
      }
    }
    if (replacer != null) {
      obj = JSON.parse(string);
      replacer = undefined;
    }
    if (_typeof(obj) === "object" && obj !== null) {
      var nextIndent = currentIndent + indent;
      var items = [];
      var index = 0;
      var start;
      var end;
      if (Array.isArray(obj)) {
        start = "[";
        end = "]";
        var _obj = obj,
          _length = _obj.length;
        for (; index < _length; index++) {
          items.push(_stringify(obj[index], nextIndent, index === _length - 1 ? 0 : 1) || "null");
        }
      } else {
        start = "{";
        end = "}";
        var keys = Object.keys(obj);
        var _length2 = keys.length;
        for (; index < _length2; index++) {
          var key = keys[index];
          var keyPart = "".concat(JSON.stringify(key), ": ");
          var value = _stringify(obj[key], nextIndent, keyPart.length + (index === _length2 - 1 ? 0 : 1));
          if (value !== undefined) {
            items.push(keyPart + value);
          }
        }
      }
      if (items.length > 0) {
        return [start, indent + items.join(",\n".concat(nextIndent)), end].join("\n".concat(currentIndent));
      }
    }
    return string;
  }(passedObj, "", 0);
}